import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eunb5c9cgs: FaireBrandEntity = {
  token: "b_eunb5c9cgs",
  type: "brand",
  name: "Down to Earth Pottery",
  avatarUrl: "https://cdn.faire.com/fastly/368d4459fd311987ee69a8478de12c301eebf1a915db913efc617595bf53eb36.png",
  bannerUrl: "https://cdn.faire.com/fastly/edc21c5c06a59af2825a9fab75c726162a0dca73f22e739a88a2d6004d6d9a92.png",
  logoUrl: "https://cdn.faire.com/fastly/368d4459fd311987ee69a8478de12c301eebf1a915db913efc617595bf53eb36.png",
  heroImageUrl: "https://cdn.faire.com/fastly/edc21c5c06a59af2825a9fab75c726162a0dca73f22e739a88a2d6004d6d9a92.png",
  location: "Colorado Springs, CO, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 447,
  isTopShop: true,
  isInsider: true,
  description: "Down to Earth Pottery is a made in the USA pottery studio that resides in Colorado Springs Colorado. We specialize in pottery with recycled glass inside our dishes. No two of our hand made dishes are exactly alike. Making it exciting every time you get your next order from us.",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:15:43.872Z",
    importedBy: "entity-db-cli"
  }
};
